@if (client && course) {
	<div class="fade-in">
		<app-course-title>{{ course.active_text?.name }}</app-course-title>
		<p>{{ course.active_text?.description_short }}</p>
		@for (unit of course.unit; track unit) {
			@if (unit) {
				<app-unit-box>
					<app-unit-title>{{ unit.active_text?.name }}</app-unit-title>
					<br />
					<div class="lesson-tile-grid">
						@for (lesson of unit.lesson; track lesson; let i = $index) {
							<app-lesson-tile
								[ngClass]="['fade-in-with-wait-' + i]"
								[lesson]="lesson"
								(click)="selectLesson(lesson)"
							></app-lesson-tile>
						}
					</div>
				</app-unit-box>
			}
		}
	</div>
}
